// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#909399","menuActiveText":"#ffb329","subMenuActiveText":"#f4f4f5","menuBg":"#fff","menuHover":"#efefef","subMenuBg":"#1f2d3d","subMenuHover":"#001528","sideBarWidth":"210px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/sider.scss
// module id = Ygl8
// module chunks = 9